<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
  <g clip-path="url(#a)">
    <path d="M10.417 6.667a8.72 8.72 0 0 0-5.75 2.166l-3-3v7.5h7.5L6.15 10.317C7.308 9.35 8.783 8.75 10.417 8.75a6.676 6.676 0 0 1 6.333 4.583l1.975-.65c-1.158-3.491-4.433-6.016-8.308-6.016Z"/>
  </g>
  <defs>
    <clipPath id="a">
      <path d="M0 0h20v20H0z"/>
    </clipPath>
  </defs>
</svg>
